import { useQuery } from '@apollo/client'
import { object } from 'prop-types'
import React, {
  createContext,
  useEffect,
  useState,
  useMemo,
  useReducer,
} from 'react'
import GET_SUBMITTED_TEMPLATE from '../apollo/queries/GET_SUBMITTED_TEMPLATE'
import { TEMPLATE_CATEGORY } from '../apollo/queries/GET_TEMPLATE_OVERVIEW'

export const MaintenancePackageContext = createContext({})

const MaintenancePackageProvider = ({ children }) => {
  const [pointsRemaining, setPointsRemaining] = useState(0)
  const [hasFileToUpload, setHasFileToUpload] = useState(false)
  const [uploadInProgress, setUploadInProgress] = useState(false)

  const { data } = useQuery(GET_SUBMITTED_TEMPLATE, {
    variables: {
      templateCategory: TEMPLATE_CATEGORY.MAINTENANCE_PACKAGE,
      isAsc: false,
    },
  })

  //Retrieve points balance from latest transaction which may use all remaining points
  // resulting in a 0 balance
  const remainingPoints = useMemo(() => {
    return data?.submittedTemplates?.find(
      template => !!template?.remainingPoints || !!template?.pointsValue
    )?.remainingPoints
  }, [data])

  useEffect(() => {
    setPointsRemaining(remainingPoints)
  }, [remainingPoints])

  const [uploadFileList, dispatch] = useReducer(
    (uploadFileList, { type, value }) => {
      switch (type) {
        case 'add': {
          const foundIndex = uploadFileList.findIndex(
            a => a.name === value.name
          )
          if (foundIndex !== -1) {
            uploadFileList = uploadFileList.filter(
              (_, index) => index !== foundIndex
            )
          }
          const updatedList = [...uploadFileList, value]
          const uploadLoading = updatedList?.some(a => a.isLoading)
          setUploadInProgress(uploadLoading)

          return updatedList
        }
        case 'removeByName': {
          const foundIndex = uploadFileList.findIndex(a => a.name === value)
          return uploadFileList.filter((_, index) => index !== foundIndex)
        }
        default:
          return uploadFileList
      }
    },
    []
  )

  return (
    <MaintenancePackageContext.Provider
      value={{
        pointsRemaining,
        uploadFileList,
        dispatch,
        hasFileToUpload,
        setHasFileToUpload,
        uploadInProgress,
      }}
    >
      {children}
    </MaintenancePackageContext.Provider>
  )
}

MaintenancePackageProvider.propTypes = {
  children: object.isRequired,
}

export default MaintenancePackageProvider
